import {useLocalStorage} from '@/composables/use-local-storage.js'
import {ref, watch} from 'vue'

//Get local storage helpers
const {getFromLocalStorage, setInLocalStorage} = useLocalStorage()

//Global flag
const isDebugMode = ref(getFromLocalStorage('isDebugMode', false))

//Update in local storage
watch(isDebugMode, () => {
  setInLocalStorage('isDebugMode', isDebugMode.value)
})

/**
 * Debug mode composable
 */
export function useDebugMode() {

  //Mutators
  const toggleDebugMode = () => isDebugMode.value = !isDebugMode.value
  const enableDebugMode = () => isDebugMode.value = true
  const disableDebugMode = () => isDebugMode.value = false

  //Debug console log
  const debugLog = (...args) => {
    if (isDebugMode.value) {
      console.log(...args)
    }
  }

  //Expose interface
  return {
    isDebugMode,
    toggleDebugMode,
    enableDebugMode,
    disableDebugMode,
    debugLog,
  }
}
